const switchBase = (environment) =>{
    switch(environment){
        case 'dev': 
            return 'http://localhost:5000';
        case 'test':
            return 'http://localhost:5000';
        case 'production':
            return '/api';
        default: 
        return 'http://localhost:5000';
    }
}
const url = switchBase(process.env.REACT_APP_NODE_ENV);

export default url;